const HEIC_TYPES = ["image/heic", "image/heif"];

// iPhones shoot in HEIC by default. Non-Safari browsers (and our own canvas
// compression pipeline) generally can't decode it, so it's converted to a
// normal JPEG client-side before anything else touches the file. heic2any
// bundles a sizeable WASM decoder, so it's dynamically imported -- loaded only
// when an actual HEIC file shows up, not added to everyone's initial bundle.
export async function convertHeicToJpeg(file) {
  const isHeic = HEIC_TYPES.includes(file.type) || /\.(heic|heif)$/i.test(file.name);
  if (!isHeic) return file;
  try {
    const { default: heic2any } = await import("heic2any");
    const result = await heic2any({ blob: file, toType: "image/jpeg", quality: 0.9 });
    const blob = Array.isArray(result) ? result[0] : result;
    return new File([blob], file.name.replace(/\.\w+$/i, "") + ".jpg", { type: "image/jpeg" });
  } catch {
    return file; // let server-side validation reject it if it's truly unreadable
  }
}
